import { languageMap } from ".."

languageMap.adoc = languageMap.asciidoc = {
	comments: {
		line: "//",
	},
}
